import { MARKETPLACE, SHOP_NAME } from "@acc/shared"
import BaseApi from "../../../api/api"
import { IOrder, ISupply } from "../../../app/reducers/ordersReducer"
import { NotificationService } from "../../../features/NotificationService/NotificationService"
import { loadAuditFormOrder } from "../../../utils/auditFormOrder"
import { RecodeSamsonWbType } from "../../Samson/UpdateStocks/wb/recode"
import { MissOrderSamson, RecodeForOrderSamson } from "../FormSamsonOrder"

export const getWBOrdersForSamson = (
  supplies: ISupply[],
): Promise<{
  recodeForOrderSamson: RecodeForOrderSamson[]
  missOrders: MissOrderSamson[]
}> => {
  const orders: IOrder[] = supplies?.reduce<IOrder[]>((res, supp) => {
    return [...res, ...(supp?.orders || [])]
  }, [])
  return Promise.all([
    BaseApi.getRecodeSamson(),
    loadAuditFormOrder(
      SHOP_NAME.SAMSON,
      MARKETPLACE.WB,
      supplies.map((supply) => supply.id),
    ),
  ]).then(
    ([{ items, success }, audit]: [
      {
        items: RecodeSamsonWbType[]
        success: boolean
      },
      audit: { date: string; value: string }[][],
    ]) => {
      if (success) {
        const info = audit?.reduce<
          {
            name: string
            value: string
            count: number
            date: string
          }[]
        >((acc, item) => {
          if (item.length) {
            const firstItem = item.sort(
              (a, b) => (new Date(b.date) as any) - (new Date(a.date) as any),
            )?.[0]
            const supp = supplies.find(
              (supply) => supply.id === firstItem.value,
            )
            supp &&
              acc.push({
                name: supp?.name,
                value: firstItem.value,
                count: item.length,
                date: firstItem.date,
              })
          }
          return acc
        }, [])
        if (items?.length) {
          const missOrders: MissOrderSamson[] = []
          const recodeForOrderSamsonMap = new Map<
            string,
            RecodeForOrderSamson
          >()

          orders.forEach((order) => {
            const recodeItem = items.find((item) => item.nmId === order.nmId)
            if (recodeItem?.GoodCode) {
              if (recodeForOrderSamsonMap.has(recodeItem.GoodCode)) {
                const recodeForOrderSamsonItem = recodeForOrderSamsonMap.get(
                  recodeItem.GoodCode,
                )
                if (recodeForOrderSamsonItem) {
                  recodeForOrderSamsonItem.quantity +=
                    Number(recodeItem.count) || 0
                } else {
                  recodeForOrderSamsonMap.set(recodeItem.GoodCode, {
                    article: recodeItem.article,
                    quantity: Number(recodeItem.count) || 0,
                  })
                }
              } else {
                recodeForOrderSamsonMap.set(recodeItem.GoodCode, {
                  article: recodeItem.article,
                  quantity: Number(recodeItem.count) || 0,
                })
              }
            } else {
              missOrders.push({ nmId: order.nmId, goodCode: order.article })
            }
          })

          return {
            recodeForOrderSamson: Array.from(recodeForOrderSamsonMap.values()),
            missOrders,
            info,
          }
        } else {
          NotificationService.showNotification({
            message: "Перекодировка не найдена",
            level: "error",
          })
          throw new Error("Перекодировка не найдена")
        }
      } else {
        NotificationService.showNotification({
          message: "Ошибка при загрузке перекодировки",
          level: "error",
        })
        throw new Error("Ошибка при загрузке перекодировки")
      }
    },
  )
}
